import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { H2, FlexPanel, Button } from 'Common';
import { showToast } from 'Utils/toastUtils';
import { t } from 'Utils/localization/i18next';
import analytics from 'Utils/analytics/analyticsWrapper';
import { getRedirectURLForUpdatePassword } from 'Redux/profile/profileThunks';
import arrowRight from '@ingka/ssr-icon/paths/arrow-right';
import styles from './LoginSecurity.module.scss';

class PasswordSectionReadContainer extends React.PureComponent {
  onEdit = async e => {
    e.preventDefault();
    const redirectURL = await this.props.getRedirectURLForUpdatePassword();
    if (redirectURL) {
      analytics.userProfileFormUpdate({
        status: 'started',
        form: `${this.props.profileType}-dashboard-change-password`
      });
      window.location = redirectURL;
    } else {
      showToast(t('forms.errors.title'), `- ${t('forms.errors.generic')}`);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles['dashboard-section-read']}>
          <FlexPanel spread className={styles['dashboard-section-read-title']}>
            <H2 tagName="h2" headingSize="m" margin={false}>
              {t(this.props.title)}
            </H2>
            <Button
              className={styles['edit-link']}
              size="small"
              type="tertiary"
              id="password-ciam-edit-link"
              onClick={this.onEdit}
              ssrIcon={arrowRight}
              href="#"
            >
              {t('dashboard.account.edit.password')}
            </Button>
            <Button
              className={styles['edit-link-mobile']}
              id="password-ciam-edit-link-mobile"
              onClick={this.onEdit}
              aria-label={t('dashboard.account.edit.password')}
              ssrIcon={arrowRight}
              size="small"
              type="tertiary"
              iconOnly
              href="#"
            ></Button>
          </FlexPanel>
          <FlexPanel>{t(this.props.title)}</FlexPanel>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

PasswordSectionReadContainer.propTypes = {
  profileType: PropTypes.string,
  editForm: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  // From Redux/Thunks
  getRedirectURLForUpdatePassword: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    profileType: state.profile.profileType
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getRedirectURLForUpdatePassword }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordSectionReadContainer);
